export const Downloads = (() => {
	'use strict';

	function init() {
	}

	return {
		init: init,
	};
})();
